export default __webpack_public_path__ + "media/images/caterers-b935c4c6155213f47bd7017676e8ce45.png";